import React from "react";

import {Typography} from "@mui/material";
import {SxProps} from "@mui/material/styles";
import {typografNode} from "../../utils/typograf";

type H5Props = {
    children: React.ReactNode;
    sx?: SxProps;
    className?: string;
};

function H5({children, sx, className}: H5Props) {
    return (
        <Typography component="h5" variant="h5" sx={[{
            fontWeight: '800',
            fontFamily: 'Nexa ExtraBold, Nexa Heavy, Nexa, Roboto, sans-serif',
            letterSpacing: 0,
            '@media screen and (min-width: 1400px)': {
                fontSize: '28px',
                lineHeight: 1.4,
            },
            '@media screen and (min-width: 1200px)': {
                fontSize: '28px',
                lineHeight: 1.3,
            },
            '@media screen and (max-width: 767px)': {
                fontSize: '20px',
                lineHeight: 1.5,
            },
            '@media screen and (min-width: 576px) and (max-width: 767px)': {
                lineHeight: 1.3,
            },
            '@media screen and (max-width: 575px)': {
                fontFamily: 'Nexa ExtraBold, Nexa Heavy, Nexa, Roboto, sans-serif',
                fontWeight: 800,
                lineHeight: 1.3,
            },
            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                fontSize: '24px',
                lineHeight: 1.3,
                overflowWrap: 'normal',
            },
        }, ...(Array.isArray(sx) ? sx : [sx ?? false])]} className={className}>
            {typografNode(children)}
        </Typography>
    );
}

export default H5
